import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UrlParamsService } from 'src/app/shared/services/url-params.service';
import { RegistrationService } from '../../../registration.service';
import { PublicMeetingDTO } from '../../../types/PublicMeetingDTO';

@Component({
  selector: 'app-in-person-confirmation',
  imports: [],
  templateUrl: './in-person-confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './in-person-confirmation.component.scss',
})
export class InPersonConfirmationComponent implements OnInit {
  @ViewChild('nextAttendeeButton')
  nextAttendeeButton!: ElementRef<HTMLButtonElement>;
  meetingInfo: PublicMeetingDTO | null = null;

  constructor(
    private registrationService: RegistrationService,
    private urlParamsService: UrlParamsService
  ) {}

  ngOnInit(): void {
    this.registrationService.meetingInfo$.subscribe({
      next: (meetingInfo) => {
        this.meetingInfo = meetingInfo;
      },
      error: (error) => {
        console.error('Error fetching meeting info:', error);
      },
    });
  }

  onNextAttendee(): void {
    this.urlParamsService.removeStakeGuid();
    this.urlParamsService.navigateWithParams('/registration/in-person');
  }
}
